module.exports = __webpack_public_path__ + "static/img/btn_3.0b8d935.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_3.png
// module id = tIaa
// module chunks = 1